import React from 'react';
import {
  LayoutDashboard, Users, Shield, Settings, Mail, Key, Server,
  MessageSquare, FileText, Database, Layers, Cpu, Terminal, Activity,
  User, Building2, UploadCloud, DollarSign, Megaphone, Lightbulb,
  Briefcase, Target, Wrench, ClipboardList, BarChart3, CreditCard,
  TrendingUp, Calendar, Image, Map, GitBranch, Truck, BookOpen,
  HelpCircle, Box, Lock, Award, Folder, Zap, Search, HeartHandshake,
  Monitor, PieChart, Rocket, Package, UserCheck, GraduationCap,
  Headphones, Laptop, Crown, Gauge, CheckCircle, Home, Bell,
  Palette, Network, GitMerge, AlertTriangle, AlertCircle, RefreshCw,
  FlaskConical, Scale, type LucideIcon
} from 'lucide-react';

/**
 * Maps string icon names (stored in template JSONB) to lucide-react components.
 *
 * Templates store icons as strings like "dollar-sign". The renderer resolves
 * these to React icon components via this map.
 */
const ICON_MAP: Record<string, LucideIcon> = {
  // Platform admin icons (match existing nav)
  'dashboard': LayoutDashboard,
  'users': Users,
  'security': Shield,
  'settings': Settings,
  'mail': Mail,
  'key': Key,
  'server': Server,
  'ai': MessageSquare,
  'file-text': FileText,
  'database': Database,
  'layers': Layers,
  'shield': Shield,
  'cpu': Cpu,
  'terminal': Terminal,
  'activity': Activity,
  'user': User,
  'building': Building2,
  'upload-cloud': UploadCloud,

  // Corporate OS / functional area icons
  'dollar-sign': DollarSign,
  'megaphone': Megaphone,
  'lightbulb': Lightbulb,
  'briefcase': Briefcase,
  'target': Target,
  'wrench': Wrench,
  'clipboard': ClipboardList,
  'bar-chart': BarChart3,
  'credit-card': CreditCard,
  'trending-up': TrendingUp,
  'calendar': Calendar,
  'image': Image,
  'map': Map,
  'git-branch': GitBranch,
  'truck': Truck,
  'book': BookOpen,
  'help-circle': HelpCircle,
  'box': Box,
  'lock': Lock,
  'award': Award,
  'folder': Folder,
  'zap': Zap,
  'search': Search,
  'handshake': HeartHandshake,
  'people': Users,
  'monitor': Monitor,
  'pie-chart': PieChart,
  'rocket': Rocket,
  'package': Package,
  'user-check': UserCheck,
  'graduation-cap': GraduationCap,
  'headphones': Headphones,
  'laptop': Laptop,

  // Additional icons for functional area dashboards (WQ-087a)
  'crown': Crown,
  'gauge': Gauge,
  'check-circle': CheckCircle,
  'layout-dashboard': LayoutDashboard,
  'home': Home,
  'bell': Bell,
  'palette': Palette,
  'network': Network,
  'git-merge': GitMerge,
  'alert-triangle': AlertTriangle,
  'alert-circle': AlertCircle,
  'refresh-cw': RefreshCw,
  'flask': FlaskConical,
  'scale': Scale,
};

const FALLBACK_ICON: LucideIcon = Layers;

/**
 * Resolve an icon string name to a rendered React element.
 */
export function resolveIcon(name: string | undefined, size: number = 18): React.ReactNode {
  if (!name) return <FALLBACK_ICON size={size} />;
  const IconComponent = ICON_MAP[name] || FALLBACK_ICON;
  return <IconComponent size={size} />;
}

/**
 * Get the icon component class (for cases where you need the component, not the element).
 */
export function getIconComponent(name: string): LucideIcon {
  return ICON_MAP[name] || FALLBACK_ICON;
}

export { ICON_MAP };
export default ICON_MAP;
